import { defineTool } from '@/shell/tool';

/** Students (Flutter `/students`). */
export default defineTool({
  id: 'students',
  title: 'Students',
  summary:
    'Find a student, and read their lessons, their course and their progress.',
  section: 'users',
  order: 30,
  icon: 'mood',
  owner: '@Drabu',
  permission: 'students:use',
  routes: () => import('./StudentsPage'),
});
